<template>
  <b-row class="m-0">
    <b-col>

      <b-row class="footerc">
        <b-col
          md="12"
          class="text-center m-2"
        >
          <h4>
            Campus Virtual INDETEC
          </h4>
          <h4>
            Instituto para el Desarrollo Técnico de las Haciendas Públicas
          </h4>
        </b-col>
      </b-row>

      <b-row class="footerc">
        <b-col
          class="footLink"
          md="3"
        >
          <div class="text-center mx-3">
            <p>
              <router-link
                :to="{ name: 'contacto'}"
              >
                <b>Soporte Técnico</b>
              </router-link>
            </p>

            <p>
              <router-link
                :to="{ name: 'contacto'}"
              >
                <b>Contacto</b>
              </router-link>
            </p>

            <p>
              <router-link
                :to="{ name: 'public-faq'}"
              >
                <b>Preguntas Frecuentes</b>
              </router-link>
            </p>
          </div>
        </b-col>

        <b-col md="6">
          <div class="text-center mx-1">

            <b-row class="text-center mx-2">
              <b-col>
                <p class="mx-3">
                  <feather-icon
                    icon="MapIcon"
                    size="21"
                    class="text-primary stroke-current"
                  />
                  Calle Paseo del Alba No. 1276, Esquina Con Av. Gral. Ramón Corona, Col. Solares Residencial C.P. 45019,
                  Zapopan, Jalisco. México.</p>
                <p><feather-icon
                  icon="SmartphoneIcon"
                  size="21"
                  class="text-primary stroke-current"
                /> 33-3669-5550 al 5559</p>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col>
                <b-row class="footerc">
                  <b-col
                    class="text-center m-2"
                  >
                    <div>
                      <b-button
                        v-b-modal.modal-f2
                        variant="outline"
                        pill
                      >
                        <b>Aviso de Privacidad Integral</b>
                      </b-button>
                      <!-- basic modal -->
                      <b-modal
                        id="modal-f2"
                        ref="modal-avisoprivacidad"
                        scrollable
                        title="AVISO DE PRIVACIDAD INTEGRAL - INDETEC "
                        size="lg"
                        ok-only
                        ok-title="Aceptar"
                        button-size="sm"
                      >
                        <avisoprivacidadintegral />
                      </b-modal>
                    </div></b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row class="footerc">
                  <b-col
                    class="text-center m-2"
                  ><b-button
                     v-b-modal.modal-f1
                     variant="outline"
                     pill
                   >
                     <b>Aviso de Privacidad Simplificado</b>
                   </b-button>
                    <!-- basic modal -->
                    <b-modal
                      id="modal-f1"
                      scrollable
                      title="AVISO DE PRIVACIDAD SIMPLIFICADO - INDETEC "
                      size="lg"
                      ok-only
                      ok-title="Aceptar"
                      button-size="sm"
                    >
                      <avisoprivacidadsimplificado />
                    </b-modal>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

          </div>
        </b-col>

        <b-col md="3">
          <div class="text-center mx-3">
            <p>Puedes seguirnos en</p>
            <b-link
              href="https://www.facebook.com/INDETECMX/"
              target="_blank"
            >
              <feather-icon
                class="m-1 text-primary stroke-current"
                size="21"
                icon="FacebookIcon"
              />
            </b-link>
            <b-link
              href="https://www.instagram.com/indetec_mx/"
              target="_blank"
            >
              <feather-icon
                class="m-1 text-primary stroke-current"
                size="21"
                icon="InstagramIcon"
              />
            </b-link>
            <b-link
              href="https://twitter.com/indetec_mx?lang=es"
              target="_blank"
            >
              <feather-icon
                class="m-1 text-primary stroke-current"
                size="21"
                icon="TwitterIcon"
              />
            </b-link>
          </div>
        </b-col>
      </b-row>

      <b-row class=" mb-0 text-center copyright">
        <b-col>
          <p>
            <span class="d-block d-md-inline-block mt-25">
              Derechos Reservados © INDETEC  {{ new Date().getFullYear() }}
            </span>
          </p>
        </b-col>
      </b-row>

    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BLink, BButton, VBModal, BModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import avisoprivacidadintegral from '@core/layouts/components/footer/avisoprivacidad.vue'
import avisoprivacidadsimplificado from './footer/avisoprivacidadsimplificado.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BModal,
    avisoprivacidadsimplificado,
    BButton,
    avisoprivacidadintegral,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
}
</script>
<style>

.footLink a{
  color: #adabab;
}
.footLink a:hover{
  color: #aa9d6b;
}

.footerc p, .footerc h4{
  color : #adabab;
}
.footerc .btn {
color: #adabab !important;
}
.footerc .btn :hover{
color: #aa9d6b !important;
}

.copyright {
background-color: #1b1b1b;
background-color:#0d111d;
color: #adabab;
}
.footerc{
background-color: #2b2b2b;
background-color: #101523;
}
@media only screen and (max-width: 600px) {
  footer.footer {
    padding: 0 !important;
}}

</style>
